import { ref, computed } from '@vue/composition-api'
import { newsFeedMetrics } from '../Services'
import { buildMockFieldUserInsights } from '../utils/mockFieldUserInsights'

export function useFieldInsights () {
  const users = ref([])
  const selectedUserId = ref(null)
  const loadingUsers = ref(false)
  const errorUsers = ref(null)

  const selectedUser = computed(() => users.value.find(u => u.id === selectedUserId.value) ?? null)

  const selectedInsights = computed(() => {
    if (selectedUserId.value == null) return null
    return buildMockFieldUserInsights(selectedUserId.value)
  })

  async function fetchUsers () {
    loadingUsers.value = true
    errorUsers.value = null
    try {
      const data = await newsFeedMetrics()
      users.value = (data.created_by_count ?? []).map(item => ({
        id: item.created_by,
        name: item.concat,
        occurrences: item.occurrences
      }))
    } catch (e) {
      errorUsers.value = e.message
    } finally {
      loadingUsers.value = false
    }
  }

  function selectUser (userId) {
    selectedUserId.value = userId
  }

  function clearSelection () {
    selectedUserId.value = null
  }

  return {
    users,
    selectedUserId,
    selectedUser,
    selectedInsights,
    loadingUsers,
    errorUsers,
    fetchUsers,
    selectUser,
    clearSelection
  }
}



// WEBPACK FOOTER //
// ./src/app/news_feed/compositions/useFieldInsights.js